import React from 'react'
import ReactDOM from 'react-dom/client'
import '@src/index.css'
import reportWebVitals from '@src/reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import App from '@src/App'
import { MantineProvider } from '@mantine/core'
import ServiceChatWrapper from '@src/components/ServiceChatWrapper'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MantineProvider>
        <ServiceChatWrapper>
          <App />
        </ServiceChatWrapper>
      </MantineProvider>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
